import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
import classes from './CanteenList.module.scss';
import { canteenMenu } from '../../API/API';

const CanteenList = () => {
    const data = JSON.parse(localStorage.getItem('data'));
    const modules = JSON.parse(localStorage.getItem('modules'));
    const navigate = useNavigate();
    const userID = localStorage.getItem('userID');
    const [menu, setMenu] = useState([{
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: []
    }]);
    const [disableBtn, setDisableBtn] = useState(false);
    const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let d = new Date();
    let day = weekday[d.getDay()];

    const [todayMenu, setTodayMenu] = useState([]);
    const [currentDay, setCurrentDay] = useState(day)


    useEffect(() => {
        if (data !== null && userID !== null) {
            canteenMenu(userID, data.empid, data.token, data.company)
                .then(response => {
                    const Monday = response.data.filter((item) => {
                        return item.fday === "Monday"
                    })
                    const Tuesday = response.data.filter((item) => {
                        return item.fday === "Tuesday"
                    })
                    const Wednesday = response.data.filter((item) => {
                        return item.fday === "Wednesday"
                    })
                    const Thursday = response.data.filter((item) => {
                        return item.fday === "Thursday"
                    })
                    const Friday = response.data.filter((item) => {
                        return item.fday === "Friday"
                    })
                    const Saturday = response.data.filter((item) => {
                        return item.fday === "Saturday"
                    })
                    setMenu({
                        Monday: Monday[0],
                        Tuesday: Tuesday[0],
                        Wednesday: Wednesday[0],
                        Thursday: Thursday[0],
                        Friday: Friday[0],
                        Saturday: Saturday.length === 0 ? { fday: "Saturday", bfast: "Weekend Off", lunch: "Weekend Off", htea: "Weekend Off", others: "Weekend Off" } : Saturday[0]
                    })

                })
        }
        return () => {

        }
    }, [userID]);


    const nextDay = () => {
        let next;
        const currentIndex = weekday.indexOf(currentDay);
        console.log(currentIndex)
        if (currentIndex === -1) {
            // Handle the case when currentDay is not found in weekday array            
            return;
        }
        if (currentIndex === weekday.length - 1) {
            next = weekday[0]; // Wrap around to the first day
        }         
        else {
            next = weekday[currentIndex + 1];
        }
        setCurrentDay(next);
    };

    const prevDay = () => {
        let previous;
        const currentIndex = weekday.indexOf(currentDay);
        console.log(currentIndex)
        if (currentIndex === -1) {
            // Handle the case when currentDay is not found in weekday array
            return;
        }
        if (currentIndex === 0) {
            previous = weekday[weekday.length - 1]; // Wrap around to the last day
        }
        else {
            previous = weekday[currentIndex - 1];
        }
        setCurrentDay(previous);
    };

    useEffect(() => {
        if (menu !== null) {
            setTodayMenu(Object.values(menu).find(item => item.fday === currentDay));
        }
    }, [menu, currentDay]);


    return (
        <>
            <BreadCrumb name="Canteen Menu" />
            <div className={classes.Container}>
                <div className={classes.ListDiv}>
                    <div className={classes.Days}>
                        <p onClick={prevDay}>Prev</p>
                        <h2>{currentDay}</h2>
                        <p style={disableBtn ? { backgroundColor: 'grey', color: "white" } : {}} onClick={nextDay}>Next</p>
                    </div>
                    <div className={classes.CanteenMenu}>
                        {todayMenu ?
                            (
                                <>
                                    <div className={classes.CanteenMenuDiv}>
                                        <div className={classes.item}>
                                            <div valign='top'><h3>Breakfast:</h3></div>
                                            <div valign='top'><p>{todayMenu.bfast}</p></div>
                                        </div>
                                        <div className={classes.item}>
                                            <div valign='top'><h3>Lunch:</h3></div>
                                            <div valign='top' style={{ display: "flex", flexDirection: 'column', gap: "0px" }} ><>{todayMenu.lunch ? (todayMenu.lunch.split('/').map(((item, index) => {
                                                return <p key={index}>{item}</p>
                                            }))) : " "}</></div>
                                        </div>
                                        <div className={classes.item}>
                                            <div valign='top'><h3>Evening Snacks:</h3></div>
                                            <div valign='top'><p>{todayMenu.htea}</p></div>
                                        </div>

                                        {/* /// OTHER SNACKS /// */}
                                        {/* <div className={classes.item}>
                                            <div valign='top'><h3>Others:</h3></div>
                                            <div valign='top'><p>{todayMenu.others}</p></div>
                                        </div> */}
                                    </div>
                                </>
                            ) : (<>
                                <div className={classes.CanteenMenuDiv}>
                                    <div className={classes.item}>
                                        <div valign='top'><h3>Breakfast:</h3></div>
                                        <div valign='top'><p>Weekend Off</p></div>
                                    </div>
                                    <div className={classes.item}>
                                        <div valign='top'><h3>Lunch:</h3></div>
                                        <div valign='top' style={{ display: "flex", flexDirection: 'column', gap: "0px", alignItems: "center", justifyContent: "center" }} ><p>Weekend Off</p></div>
                                    </div>
                                    <div className={classes.item}>
                                        <div valign='top'><h3>Evening Snacks:</h3></div>
                                        <div valign='top'><p>Weekend Off</p></div>
                                    </div>

                                    {/* //////  OTHER SNACKS ////// */}
                                    {/* <div className={classes.item}>
                                        <div valign='top'><h3>Other:</h3></div>
                                        <div valign='top'><p>Weekend Off</p></div>
                                    </div> */}
                                    {/* ///// End /////// */}

                                </div>
                            </>)}
                    </div>
                </div>

            </div>
        </>
    )
}

export default CanteenList